import { useState } from 'react'
import MainPageWrapper from '../../../global/components/MainPageWrapper'
import TechniciansTable from '../table/TechniciansTable'
import { TechnicianModal } from '../technician-modal/components/container-modal/TechnicianModal'
import TechnicianPageHeader from './new-technician/TechnicianPageHeader'

export interface IDefaultLocationTimesProps {
  locationId: string | null
  defaultWorkDayFrom: string | null
  defaultWorkDayTo: string | null
  defaultLunchFrom: string | null
  defaultLunchTo: string | null
}

function TechniciansMain() {
  const [open, setOpen] = useState({
    isOpen: false,
    techId: '',
  })

  const handleClosed = () => {
    setOpen({ isOpen: false, techId: '' })
  }

  return (
    <MainPageWrapper titleFields={<TechnicianPageHeader />}>
      <TechnicianModal
        technicianObjectId={open.techId}
        isOpen={open.isOpen}
        handleClosed={handleClosed}
      />
      <TechniciansTable setOpen={setOpen} />
    </MainPageWrapper>
  )
}

export default TechniciansMain
